import { pushRoute } from "../../../common/route"

export const toLink = link => () => {
  pushRoute(link, true)
}



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/common.js